export default __webpack_public_path__ + "static/media/exclamation.077be817.png";